import {useReducer} from 'react';
import PerformanceEvaluationResultsContext, {initialState} from "./PerformanceEvaluationResultsContext";
import PerformanceEvaluationResultsReducer from './PerformanceEvaluationResultsReducer';

const PerformanceEvaluationResultsState = (props:any) => {
    const [state,dispatch] = useReducer(PerformanceEvaluationResultsReducer, initialState)
    return (
        <PerformanceEvaluationResultsContext.Provider value={{state,dispatch}}>
                  {props.children}
        </PerformanceEvaluationResultsContext.Provider>
    )
}

export default PerformanceEvaluationResultsState;